import { useState, useEffect } from 'react';

interface UseToastReturn {
  showToast: boolean;
  toastMessage: string;
  show: (message: string) => void;
  hide: () => void;
}

export const useToast = (duration: number = 2000): UseToastReturn => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => {
        setShowToast(false);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [showToast, duration]);

  const show = (message: string) => {
    setToastMessage(message);
    setShowToast(true);
  };

  const hide = () => {
    setShowToast(false);
  };

  return {
    showToast,
    toastMessage,
    show,
    hide,
  };
};

